import { render, staticRenderFns } from "./BannerEditor.vue?vue&type=template&id=016f88d6&scoped=true&"
import script from "./BannerEditor.vue?vue&type=script&lang=js&"
export * from "./BannerEditor.vue?vue&type=script&lang=js&"
import style0 from "./BannerEditor.vue?vue&type=style&index=0&id=016f88d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f88d6",
  null
  
)

export default component.exports